//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { OrderbumpsContext } from "../context/OrderbumpsContext";



//--------------- EXPORTAÇÃO DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
export default function ContainerTableOrigins() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { data, setData } = useContext(OrderbumpsContext); // Estado que armazena os Dados da busca feita pelo usuário



    //--------------- RETORNO CONDICIONAL DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
    return (
        <>
            {!data?.origens?.length
                ? null
                :
                <>
                    <div className="gap-2 w-full bg-surface-2 border border-white/[0.08] rounded-t-xl">
                        <h2 className="text-lg font-semibold text-blue-400 py-2 px-3 mb-2">Origem das Vendas do Produto Principal</h2>
                    </div>
                    <div className="bg-surface-2 rounded-b-xl scrollbar scrollbar-thumb-zinc-700 scrollbar-track-zinc-900 overflow-x-scroll shadow border border-white/[0.08]">
                        <table className="sm:w-full text-xs sm:text-sm table-auto">
                            <thead className="border-b border-white/[0.08]">
                                <tr className="text-left">
                                    <th className="py-2 px-3">Origem</th>
                                    <th className="py-2 px-3">Quantidade</th>
                                    <th className="py-2 px-3">Total Valor (R$)</th>
                                    <th className="py-2 px-3">Valor Produtor (R$)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.origens.map((o, idx) => (
                                    <tr key={idx} className="border-b border-white/[0.06] text-left hover:bg-surface-3/30">
                                        <td className="py-2 px-3 break-words max-w-[180px]">{o.origem}</td>
                                        <td className="py-2 px-3">{o.quantidade}</td>
                                        <td className="py-2 px-3">R$ {o.total_valor.toFixed(2)}</td>
                                        <td className="py-2 px-3">R$ {o.total_valor_produtor.toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </>
            }
        </>
    );
}

{/* <div className="gap-2 mb-6 w-full bg-surface-2 rounded-xl">
                        <h2 className="text-lg font-semibold mb-4 text-blue-400 pt-2 px-3">Origem das Vendas do Produto Principal</h2>
                        <div className="bg-surface-2 rounded-b-xl overflow-hidden scrollbar scrollbar-thumb-zinc-700 scrollbar-track-zinc-900 overflow-x-scroll shadow border border-white/[0.08]">
                            <table className="w-[1080px] sm:w-full text-xs sm:text-sm table-fixed">
                                <thead className="border-b border-white/[0.08]">
                                    <tr>
                                        <th className="py-2 px-3">Origem</th>
                                        <th className="py-2 px-3">Quantidade</th>
                                        <th className="py-2 px-3">Total Valor (R$)</th>
                                        <th className="py-2 px-3">Valor Produtor (R$)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.origens.map((o, idx) => (
                                        <tr key={idx} className="border-b border-white/[0.06]">
                                            <td className="py-2 px-3">{o.origem}</td>
                                            <td className="py-2 px-3">{o.quantidade}</td>
                                            <td className="py-2 px-3">R$ {o.total_valor.toFixed(2)}</td>
                                            <td className="py-2 px-3">R$ {o.total_valor_produtor.toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div> */}
